import SingleButton, { getClassName } from '@/components/SingleButton';
import { BUTTON_TYPE, Copywriting } from '@/utils/constants';
import { classnames, getTrans } from '@/utils/tools';
import React from 'react';
import './index.scss';
import UpdateAvailableImg from '@/assets/img/update-available.png';
import { jumpToVersionUpdate } from '@/utils/tools/face';

function VersionUpdateModal(props: any) {
  const { onClose } = props;
  const titleText = getTrans(Copywriting.UPDATE_VERSION_MODAL_TITLE);
  const msgText = getTrans(Copywriting.UPDATE_VERSION_MODAL_TIP);
  const laterBtnText = getTrans(Copywriting.UPDATE_VERSION_MODAL_LATER_BUTTON);
  const updateBtnText = getTrans(Copywriting.UPDATE_VERSION_MODAL_UPDATE_BUTTON);

  const buttons = [{
    className: classnames('button-container', getClassName(BUTTON_TYPE.PRIMARY_OUTLINED)),
    text: laterBtnText,
    handleClick: () => {
      onClose();
    },
  },
  {
    className: classnames('button-container', getClassName(BUTTON_TYPE.PRIMARY)),
    text: updateBtnText,
    handleClick: () => {
      jumpToVersionUpdate();
      onClose();
    },
  }];
  return (
    <div className="version-update-modal-content">
      <div className="content-img">
        <img src={UpdateAvailableImg} />
      </div>
      <div className="content-title">
        {titleText}
      </div>
      <p className="content-msg">
        {msgText}
      </p>
      <div className="content-btn-group">
        {buttons.map((buttonProps) => {
          return <SingleButton key={buttonProps.text} {...buttonProps} />;
        })}
      </div>

    </div>
  );
}


export default VersionUpdateModal;
